import WinBase from "./winBase";
import InitGridObj from "../../../dx/dxInitUtils/initGridObj";
import {GoingUtils} from "goingutils";
import GoSingleQueryCtl from "../../../jsCom/comCtl/GoSingleQueryCtl";

class ShowGridWin extends WinBase {
    constructor(options) {
        super(options);
        this.options = {};
        let defConfig = {paddingLeft:15,paddintTop:6};
        this.options = $.extend(defConfig, options);
    }

    /**
     * 激活form窗口对象
     * @param vueObj
     * @returns {*}
     */
    showWin(vueObj) {
        //左边间距
        let paddingLeft=this.options.paddingLeft||15;
        //上面的间距
        let paddingTop=this.options.paddintTop||10;
        let divId = GoingUtils.getUUid(12);
        //查询工具栏
        let searchBar = `<div class="pull-right" style="margin:5px 10px;" id="${divId}_search"></div>`;
        if (!this.options.hasSearch) {
            searchBar = "";
        }
        let htmlContent = `${searchBar}<div id='${divId}' style='width: calc(100% - ${parseFloat(paddingLeft)*2}px);height:calc(100% - ${paddingTop}px);margin-top:${paddingTop}px;margin-left: ${parseFloat(paddingLeft)}px;'></div>`;
        //弹出窗口
        this.showDialogWin(htmlContent,this.options["closeWin"]);
        //是否存在查询
        if (this.options.hasSearch) {
            new GoSingleQueryCtl(
                divId + "_search",
                this.options.config["fieldAry"],
                vueObj,
                this.options.searchFun
            );
        }
        //初始化容器的高度
        this.initWinContainer(divId);
        //初始化表格
        this.options.config["hasPagin"] = true;
        //激活表格对象
        let gridObj = InitGridObj(divId, this.options.config, vueObj);

        //初始化底部操作栏
        this.addBottomBar(divId);
        //初始化底部事件
        this.initBottomEvent({divId,goAclWin:gridObj, vueObj,closeWin:this.options["closeWin"]});
    }

    //初始化容器的高度
   
    initWinContainer(divId) {
        let height = 76;
        if (this.options.hasSearch) {
            height = 116;
        }
        let oldHeight = $("#" + divId).height();
        $("#" + divId).height(parseFloat(oldHeight + "") - height);
        $("#" + divId)
            .closest(".layui-layer-content")
            .css("overflow", "hidden");
    }
}

export default ShowGridWin;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/go-dialog/components/showGridWin.js